/* eslint-disable camelcase */
import React, { Dispatch } from 'react';
import { useDispatch } from 'react-redux';

type TNumberOfWorkersSpinnerProps = {
    number_of_freelancers: number;
    updateField: (fieldName: string, value: any) => Dispatch<void>;
};

export default function NumberOfWorkersSpinner({
    number_of_freelancers,
    updateField,
}: TNumberOfWorkersSpinnerProps) {
    const dispatch = useDispatch();

    const toggleNumFls = (e: any) => {
        const newNumberOfFreelancers = number_of_freelancers + Number(e.target.value);

        if (newNumberOfFreelancers > 0) {
            dispatch(updateField('number_of_freelancers', newNumberOfFreelancers));
        }

        e.preventDefault();
    };

    return (
        <div>
            <p className="question">How many Workers do you need?</p>
            <section className="spinner">
                <button
                    className="arrow-left"
                    onClick={toggleNumFls}
                    value={-1}
                    type="button"
                />
                <span className="buzzworkers-count">{number_of_freelancers}</span>
                <button
                    className="arrow-right"
                    onClick={toggleNumFls}
                    value={1}
                    type="button"
                />
            </section>
        </div>
    );
}
